/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { FlyInputEvent } from '@customerio/fly-components/types/fly-components/events';
import { InlineSupportPageArgs } from 'cio/components/inline-support';

export default class BodyPage extends Component<InlineSupportPageArgs> {
  @action
  handleBodyInput(event: FlyInputEvent<HTMLTextAreaElement>) {
    let value = event.target?.value;
    this.args.setFormValue('body', value);
  }

  @action
  handleVideoInput(value: string) {
    this.args.setFormValue('video', value);
  }
}
